import { SearchTypesEnum } from 'widgets/SearchDropdown'

export const getBreakdownColumnName = (filterType: SearchTypesEnum | null): string => {
  switch (filterType) {
    case SearchTypesEnum.members:
      return 'Member'
    case SearchTypesEnum.tags:
      return 'Tag'
    case SearchTypesEnum.teams:
      return 'Inbox'
    case SearchTypesEnum.numbers:
      return 'Number'
    case SearchTypesEnum.outbound_sources:
      return 'Outbound source'
    default:
      return 'Breakdown by'
  }
}
